import AddressPredictionItemDesktop from '@porterin/booking-flow/src/order-review/view/components/AddressPredictionItemDesktop';
import { useLocation } from '@porterin/component-library/src/location-accuracy/contexts/LocationContext';
import { GaEventsLocationAccuracy } from '@porterin/component-library/src/location-accuracy/store/LocationAccuracyStore';
import { publishEventParameter } from '@porterin/component-library/src/ts-utils/analytics/react-ga/EventTracker';
import {
  getScreenName,
  isDesktop,
} from '@porterin/lead-flow/src/components/FareEstimateHelper';
import React from 'react';

export interface AddressPredictionsCmpProps {
  predictions: google.maps.places.AutocompletePrediction[];
  on_prediction_click: (
    prediction: google.maps.places.AutocompletePrediction,
  ) => void;
}

const AddressPredictionsCmpDesktop: React.FC<AddressPredictionsCmpProps> = ({
  predictions,
  on_prediction_click,
}) => {
  const { state } = useLocation();

  return (
    <div className="bg-white overflow-y-auto h-[26.7rem] mt-[2rem] w-full">
      {predictions.map(address => (
        <AddressPredictionItemDesktop
          key={address.place_id}
          main_text={address.structured_formatting.main_text}
          secondary_text={address.structured_formatting.secondary_text}
          on_click={() => {
            on_prediction_click(address);
            publishEventParameter(
              state.waypoint === 'Pickup'
                ? GaEventsLocationAccuracy.pickupSelectFromSearch
                : GaEventsLocationAccuracy.dropSelectFromSearch,
              {
                category: 'Location Accuracy',
                device: isDesktop() ? 'Desktop' : 'mobile',
                screen_name: getScreenName(),
              },
            );
          }}
        />
      ))}
    </div>
  );
};

export default AddressPredictionsCmpDesktop;
